import { cloneDeep } from 'lodash'

export function sortProfessionals (profissionals) {
    return profissionals.sort((a, b) => (a.nome > b.nome) ? 1 : -1);
}

export function unpackProfessionalsFromTenant (professionals) {
    professionals.forEach((item, _) => {
        const newTenant = cloneDeep(item.tenant)

        delete item.tenant
        item.profissionais.forEach(p => {
            p['tenant'] = newTenant
        })
    })
    return professionals.map(i => i.profissionais).flat(1);
}